import React, { useEffect, useState } from 'react';
import { useRequest } from 'hooks';

import Modal from 'components/Modal';
import { MARK_TYPES } from 'utils/Constants';
import { Button, Input, Select } from 'components/Misc/Form';

import { useSubjectStudentStore } from 'store/subject/useSubjectStudentStore';

const Update = ({ mark, modal, handleModal }) => {
	// Use subject's store
	const [onUpdate, onRemove] = useSubjectStudentStore(state => [state.onUpdate, state.onRemove]);

	// Store request
	const [[updateProgress], updateRequest] = useRequest('put', `marks/${mark?.id}`);
	const [[removeProgress], removeRequest] = useRequest('delete', `marks/${mark?.id}`);

	// Store mark's data
	const [data, setData] = useState({
		type: '',
		mark: ''
	});

	// Handle payment data change
	const onChange = event => setData(prev => ({ ...prev, [event.name]: event.value }));

	// Handle submit event
	const onSubmitUpdate = async (event) => {
		event.preventDefault();

		// Try to create final
		const [success] = await updateRequest(data);

		if (success) {
			// Handle mark addition
			onUpdate(success.mark);

			// Handle modal close
			handleModal();
		}
	};

	// Handle submit event
	const onSubmitRemove = async (event) => {
		event.preventDefault();

		// Try to create final
		const [success] = await removeRequest();

		if (success) {
			// Handle mark addition
			onRemove(success.mark);

			// Handle modal close
			handleModal();
		}
	};

	useEffect(() => {
		if (mark) setData(prev => ({
			...prev,
			type: mark.type,
			mark: mark.mark
		}));
	}, [mark]);

	return (
		<Modal title="Labot vērtējumu" visible={modal} handleModal={handleModal}>
			<div className="grid grid-cols-2 gap-4">
				<Select
					name="type"
					label="Tips"
					placeholder=" "
					value={data.type}
					onChange={onChange}
					options={MARK_TYPES?.filter(type => type.value !== 'transferred')?.map(type => ({
						value: type.value,
						name: type.text
					}))}
				/>

				<Input
					type="text"
					name="mark"
					label="Vērtējums"
					value={data.mark}
					onChange={onChange}
					className="flex-1"
				/>

				<div className="col-span-2 flex justify-end gap-2">
					<Button
						progress={removeProgress}
						icon="delete"
						theme="danger"
						value="Dzēst"
						onClick={onSubmitRemove}
					/>

					<Button
						progress={updateProgress}
						icon="check"
						theme="success"
						value="Saglabāt"
						onClick={onSubmitUpdate}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Update;